export default {
  "setting.autoUpdate": "自动更新",
  "setting.localStorage": "本地存储",
  "setting.notifications": "通知",
};
